module.exports = __webpack_public_path__ + "static/367117_2_0-7751ea90eee6eb2597a75e12db5650dc.woff2";